import { Container, ContainerProps, styled } from '@mui/material';
import React, { ReactNode } from 'react';

const StyledContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(7),
  marginTop: theme.spacing(1),
}));

interface IMainContainerProps extends ContainerProps {
  children: ReactNode;
}

const MainContainer = React.forwardRef<HTMLDivElement, IMainContainerProps>((props: IMainContainerProps, ref) => {
  return (
    <StyledContainer ref={ref} maxWidth="xl" {...props}>
      {props.children}
    </StyledContainer>
  );
});
export default MainContainer;
